import { render, staticRenderFns } from "./BlogsPage.vue?vue&type=template&id=36b90d25&"
import script from "./BlogsPage.vue?vue&type=script&lang=js&"
export * from "./BlogsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports